var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list-loader-outer"},[_c('transition',{attrs:{"name":"loader-fade"}},[(_vm.loading)?_c('div',{staticClass:"list-loader"},[_c('div',{staticClass:"loader"})]):_vm._e()])],1),_vm._v(" "),_c('h1',[_vm._v("Behandlingslängder")]),_vm._v(" "),_c('div',{staticClass:"searchbar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }